var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsStoreSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.291,
    height: 5.27,
    viewBox: "0 0 9.291 5.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.022-8a.624.624,0,0,0-.441,1.066l4.019,4.022a.626.626,0,0,0,.884,0L-.541-6.934A.624.624,0,0,0-.981-8Z",
    transform: "translate(9.647 8)",
    fill: "#877b6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStoreSwitch);
export default __webpack_public_path__ + "static/media/icons_StoreSwitch.16214f81.svg";
export { ForwardRef as ReactComponent };